import { render, staticRenderFns } from "./GChatMessageArea.vue?vue&type=template&id=9c7259ca&scoped=true&"
import script from "./GChatMessageArea.vue?vue&type=script&lang=ts&"
export * from "./GChatMessageArea.vue?vue&type=script&lang=ts&"
import style0 from "./GChatMessageArea.vue?vue&type=style&index=0&id=9c7259ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7259ca",
  null
  
)

export default component.exports